import React from 'react'
import * as Avatar from '../Avatar'
import { Title } from './Title'
import { Body } from './Body'
import { View, CardViewProps } from './View'

export interface IResourceCardProps extends CardViewProps {
  resourceDocument: any // Anything typed as 'any' WAS utilizing 'ResourceDocument' from the epc schema
}

export const Resource: React.FC<IResourceCardProps> = ({
  resourceDocument,
  ...view
}) => {
  return (
    <View {...view}>
      <div className="flex items-start space-x-3">
        <div className="flex-shrink-0">
          <Avatar.Simple
            name={resourceDocument.title as string}
            maxInitials={1}
            color={resourceDocument.color as string}
            imageUrl={resourceDocument.iconUrl as string}
          />
        </div>
        <div className="flex-1 min-w-0 flex flex-col">
          <Title>{resourceDocument.title}</Title>
          <Body>{resourceDocument.excerpt}</Body>
        </div>
      </div>
    </View>
  )
}

Resource.displayName = 'Card.Resource'
